import { CALL_API } from 'Middlewares'
import moment from 'moment-timezone'
import {
    CORE_LOAD_ROOMINFO_REQUEST,
    CORE_LOAD_ROOMINFO_SUCCESS,
    CORE_LOAD_ROOMINFO_FAILURE,

    LOAD_ROOMINFO_REQUEST,
    LOAD_ROOMINFO_SUCCESS,
    LOAD_ROOMINFO_FAILURE,

    CORE_LOAD_SLOTS_REQUEST,
    CORE_LOAD_SLOTS_SUCCESS,
    CORE_LOAD_SLOTS_FAILURE,

    CORE_SEARCH_ROOMS_REQUEST,
    CORE_SEARCH_ROOMS_SUCCESS,
    CORE_SEARCH_ROOMS_FAILURE,
    CORE_ROOMS_CLEAR,

    CORE_LOAD_ROOMS_SUGGEST_REQUEST,
    CORE_LOAD_ROOMS_SUGGEST_SUCCESS,
    CORE_LOAD_ROOMS_SUGGEST_FAILURE,

    CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST,
    CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS,
    CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE,

    CORE_LOAD_ROOMS_REQUEST,
    CORE_LOAD_ROOMS_SUCCESS,
    CORE_LOAD_ROOMS_FAILURE,

    CORE_LOAD_ROOM_FORMAT_REQUEST,
    CORE_LOAD_ROOM_FORMAT_SUCCESS,
    CORE_LOAD_ROOM_FORMAT_FAILURE,

    CORE_LOAD_ROOM_TYPE_REQUEST,
    CORE_LOAD_ROOM_TYPE_SUCCESS,
    CORE_LOAD_ROOM_TYPE_FAILURE,

    CORE_SAVE_FORMSUGGEST,
    CORE_SAVE_FORMSEARCHNAME,

    CORE_LOAD_SETTINGS_REQUEST,
    CORE_LOAD_SETTINGS_SUCCESS,
    CORE_LOAD_SETTINGS_FAILURE,

    CORE_CLEAR_FORMSEARCHNAME
} from '../../types'

import {
    // timeZone,
    CORE_API_ENDPOINT,
    setCookieSetting
} from 'Lib'

export function findRoomInfo(id) {
    return {
        [CALL_API]: {
            // endpoint: `${CORE_API_ENDPOINT}/room/info/${id}`,
            endpoint: `${CORE_API_ENDPOINT}/room/booking/info/${id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_ROOMINFO_REQUEST,
                {
                    type: CORE_LOAD_ROOMINFO_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_ROOMINFO_FAILURE
            ]
        }
    }
}

export function findRoomInfoForAmenityAndService(id) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/room/info/${id}`,
            // endpoint: `${CORE_API_ENDPOINT}/room/booking/info/${id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                LOAD_ROOMINFO_REQUEST,
                {
                    type: LOAD_ROOMINFO_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                LOAD_ROOMINFO_FAILURE
            ]
        }
    }
}

export function findSlot(history, id, date, start, end) {
    let yyyymmdd = moment(date).format('YYYYMMDD')
    let urlEndPoint = `${CORE_API_ENDPOINT}/events/getslots/${id}/${yyyymmdd}`
    let historyUrl = `/roomSlots/${id}/${yyyymmdd}/${start}/${end}`
    return {
        [CALL_API]: {
            endpoint: `${urlEndPoint}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_SLOTS_REQUEST,
                {
                    type: CORE_LOAD_SLOTS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return [json.value]
                                }
                            )
                    },
                    callBack() {
                        history.push(historyUrl)
                    }
                },
                CORE_LOAD_SLOTS_FAILURE
            ]
        }
    }
}

export function searchSuggest(search) {
    let eventDate = ''
    if (search.search_date) {
        eventDate = new Date(search.search_date)
        eventDate = moment(eventDate).format('YYYYMMDD')
    }
    let startTime = ''
    if (search.search_startDateTime)
        startTime = search.search_startDateTime
    let endTime = ''
    if (search.search_endDateTime)
        endTime = search.search_endDateTime

    let capacity = ''
    if (search.capacity && search.capacity !== '0')
        capacity = search.capacity

    let floor = ''
    if (search.floorId && search.floorId !== '0') floor = search.floorId

    let roomTypeId = ''
    if (search.roomtype !== '0') roomTypeId = search.roomtype

    let amenities = ''
    if (search.amenities.length > 0) amenities = search.amenities.join(',')

    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/rooms/suggest?floor=${floor}&date=${eventDate}&start=${startTime}&end=${endTime}&capacity=${capacity}&amenities=${amenities}&roomTypeId=${roomTypeId}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_ROOMS_SUGGEST_REQUEST,
                {
                    type: CORE_LOAD_ROOMS_SUGGEST_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_ROOMS_SUGGEST_FAILURE
            ]
        }
    }
}

export function searchFirstSuggest() {

    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/rooms/firstsuggest`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST,
                {
                    type: CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE
            ]
        }
    }
}

export function clearStateRooms() {
    return {
        type: CORE_ROOMS_CLEAR
    }
}

export function searchRoom(textSearch) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/rooms/search/${textSearch}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_SEARCH_ROOMS_REQUEST,
                {
                    type: CORE_SEARCH_ROOMS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return [json.value]
                                }
                            )
                    }
                },
                CORE_SEARCH_ROOMS_FAILURE
            ]
        }
    }
}

export function findAllRoom() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/rooms/search/`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_ROOMS_REQUEST,
                {
                    type: CORE_LOAD_ROOMS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return [json.value]
                                }
                            )
                    }
                },
                CORE_LOAD_ROOMS_FAILURE
            ]
        }
    }
}

export function searchSlots(date, roomId) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/events/getslots/${roomId}/${date}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_SLOTS_REQUEST,
                {
                    type: CORE_LOAD_SLOTS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_SLOTS_FAILURE
            ]
        }
    }
}

export function findRoomFormat() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/roomformat/list`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_ROOM_FORMAT_REQUEST,
                {
                    type: CORE_LOAD_ROOM_FORMAT_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_ROOM_FORMAT_FAILURE
            ]
        }
    }
}

export function findRoomType() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/roomType/list`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_ROOM_TYPE_REQUEST,
                {
                    type: CORE_LOAD_ROOM_TYPE_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_ROOM_TYPE_FAILURE
            ]
        }
    }
}

export function saveFormSuggest(search) {

    return {
        type: CORE_SAVE_FORMSUGGEST,
        form: search
    }
}

export function saveFormSearchName(search) {

    return {
        type: CORE_SAVE_FORMSEARCHNAME,
        form: search
    }
}

export function clearStateFormSearchName() {
    return {
        type: CORE_CLEAR_FORMSEARCHNAME,
    }
}

export function findDefaultSetting() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/setting/info/`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_SETTINGS_REQUEST,
                {
                    type: CORE_LOAD_SETTINGS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    if (!!json && !!json.value) {
                                        setCookieSetting(json.value)
                                    }
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_SETTINGS_FAILURE
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/features/rooms/actions.js